(function(module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider, Store) => {

        formlyConfigProvider.setType({
            name: 'formlyGeolocation',
            template: `
                <div class="formly-geolocation" >
                    <md-input-container>
                        <input id="{{ 'geolocation' + mapEl }}" type="text" required/>
                        <div ng-messages="form.location.$error">
                            <div ng-if="!namespacedModel[key]" >Please select a location</div>
                        </div>
                    </md-input-container>
                    <div id="{{mapEl}}" class="map"></div>
                    <input ng-model="namespacedModel[key]" type="hidden" required/>
                    <div class="location" ng-if="namespacedModel[key]">Current Longitude and Latitude: <b>{{ namespacedModel[key] }}</b></div>
                </div>
            `,
            link: function(scope) {
                const options = {
                    map: `#${scope.mapEl}`,
                    mapOptions: {
                        zoom: 12
                    },
                    markerOptions: {
                        draggable: true
                    },
                };

                const update = (location) => {
                    scope.$apply(() => {
                        scope.namespacedModel[scope.key] = location;
                        scope.form.$setDirty();
                    });
                };

                const init = (options) => {
                    $(`input#geolocation${scope.mapEl}`)
                        .geocomplete(options)
                        .bind('geocode:result', (event, result) => {
                            const lng = result.geometry.location.lng();
                            const lat = result.geometry.location.lat();
                            update(`${lat},${lng}`);
                        })
                        .bind('geocode:dragged', (event, location) => {
                            const lng = location.lng();
                            const lat = location.lat();
                            update(`${lat},${lng}`);
                        });
                };


                navigator.geolocation.getCurrentPosition(function (position) {
                    const current = scope.namespacedModel[scope.key];
                    const location = current
                        ? current.split(',')
                        : new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    init({
                        ...options,
                        location,
                    });
                });

            },
            controller: ['$scope', ($scope) => {
                $scope.mapEl = `${$scope.to.mapEl || 'map'}`;
                const originalKey = $scope.options.key;
                if (originalKey.includes('.')) {
                    const [namespace, key] = originalKey.split('.');
                    $scope.namespacedModel = $scope.model[namespace];
                    $scope.key = key;
                } else {
                    $scope.namespacedModel = $scope.model;
                    $scope.key = originalKey;
                }
            }],
        });
    }]);
})(angular.module('rocket.components'));
